/**
 * Toile's terms-gate copy (plan 2026_09_01_tos_gate.md §8.2) — one attestation, shared by every
 * `TosConsentCard` instance toile renders (the wall's column/sheet and the page verb's
 * `StageComponent`). No 18+ line: toile carries no age attestation anywhere else either.
 */
export const TOILE_CONSENT_COPY = {
    attestation: 'I agree to the',
    termsLabel: 'Terms',
    conjunction: 'and',
    policyLabel: 'Privacy Policy',
}
